// generated by genversion
module.exports = '3.72.8';



//////////////////
// WEBPACK FOOTER
// ./src/utils/version.js
// module id = 1487
// module chunks = 0